<template>
  <b-overlay :show="busy" rounded="sm">
    <b-card class="standardpage reports invoices border-none">

      <b-card-header class="px-2">
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i :class="ticketschange.icon" class="mr-1"></i>
            {{ ticketschange.title }}
            <!-- {{ daterange }} -->
            <span v-if="eventcode"> for {{ eventtitle }}</span>
          </b-col>
        </b-row>
      </b-card-header>

      <div v-if="!component" class="availtable datatable">


        <div class="px-0">
          <!-- {{ ticketschange.selectall }}
          {{ ticketschange.selected.length }} -->
          <d-table classdivtable="availtable datatable" refid="ticketschange" :icon="ticketschange.icon"
            :toolbarlibrary="ticketschange.toolbarlibrary" :tools="ticketschange.tools" :badges="ticketschange.badges"
            :fields="ticketschange.fields" :items="ticketschange.items" :busy="ticketschange.busy"
            :page="ticketschange.page" :showpages="false" @load="ticketschange_load" @click="ticketschange_click"
            @select="ticketschange_select" :showrowcount="false">
          </d-table>
        </div>
      </div>
      <div v-if="component">
        <component :is="component" :selection="ticketschange.selected" :intray="inventory_type" :config="cconfig"
          @discard="ticketschange_click('discard')" @refresh="ticketschange_click('refresh')"></component>
      </div>
      <!-- <b-row>
        <b-col cols="12" sm="6" md="4" xl="3">
          :disabled="readonly_charter"
          <b-form-group label-cols="12" label="Type" label-size="sm">
            <treeselect placeholder="Type" v-model="type" :clearable="false" :multiple="false" :options="options_type"
              :matchKeys="['id']" :disabled="readonly_charter">
             
            </treeselect>
          </b-form-group>
        </b-col>
      </b-row> -->
      <div class="availtable datatable">
        <b-card class="w-100pct">
          <b-card-body class="p-0"> <b-row>
              <b-col cols="12" sm="6" md="4" xl="3">
                <!-- :disabled="readonly_charter" -->
                <b-form-group label-cols="12" label="Change Type To" label-size="sm">

                  <b-form-checkbox-group id="type" v-model="type" :options="options_type" size="sm"
                    :aria-describedby="ariaDescribedby" value-field="id" text-field="label" name="radio-options"
                    class="z-0" style="padding-top: 0.2em" :disabled="readonly_charter">
                  </b-form-checkbox-group>

                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="6" xl="6">
                <b-form-group label-cols="12" label="RI Line" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="item.line_ri" :debounce="ticketschange.debounce" placeholder="RI Line"
                      :disabled="readonly('line_ri')"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="readonly('line_ri')"
                        @click="item.line_ri = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Blocked At" label-size="sm">
                  <b-input-group>
                    <b-form-input placeholder="Blocked At" :value="item.locked_at
                      ? this.$helpers.datetimefield(item.locked_at)
                      : null
                      " :disabled="readonly()"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" class="h-29 w-30px">
                        <b-form-checkbox style="padding-left:30px; margin-top:1px" v-model="unblock" size="sm" switch>
                        </b-form-checkbox>
                      </b-button>

                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>


              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group :disabled="readonly('agent')" label-cols="12" label="Agent" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="item.agent" placeholder="Agent"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="readonly('agent')"
                        @click="item.agent = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Client SL A/C" label-size="sm">
                  <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..." v-model="item.slac"
                    :clearable="true" :async="true" :load-options="treeselect_loadSLAC" :show-count="true"
                    :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                    :disabled="readonly('slac')">
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Event" label-size="sm">
                  <treeselect placeholder="Select event..." v-model="item.eventcode" :clearable="true" :async="true"
                    :load-options="treeselect_loadEvent" searchPromptText="Type at least 4 chars..." :show-count="true" :flatten-search-results="true"
                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested :disabled="readonly('eventcode')">
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Your Ref / PO" label-for="yourref" label-cols="12">
                  <b-input-group>
                    <b-form-input type="text" v-model="item.yourref" placeholder="Your Ref / PO" size="sm"
                      :disabled="readonly('yourref')"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" :disabled="readonly('yourref')" variant="outline-secondary"
                        @click="item.yourref = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>



              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Last Name" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="item.surname" :debounce="ticketschange.debounce" placeholder="Last Name"
                      :disabled="readonly_namechange"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="readonly_namechange"
                        @click="item.surname = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="First Name" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="item.firstname" :debounce="ticketschange.debounce" placeholder="First Name"
                      :disabled="readonly_namechange"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="readonly_namechange"
                        @click="item.firstname = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Title" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="item.title" :debounce="ticketschange.debounce" placeholder="Title"
                      :disabled="readonly_namechange"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="readonly_namechange"
                        @click="item.title = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Passenger" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="item.passenger" :debounce="ticketschange.debounce" placeholder="Passenger"
                      :disabled="readonly_namechange"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="readonly_namechange"
                        @click="item.passenger = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

            </b-row></b-card-body>
        </b-card>
      </div>




      <b-card-footer class="nopadding mt-2">
        <b-row no-gutters>
          <b-col cols="auto" class="text-left">
            <b-button squared size="sm" variant="primary" @click="saveit()">
              <i class="fa fa-check"></i>
              Save It
            </b-button>
          </b-col>
          <b-col class="text-left pl-3 pt-1">
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
            </div>
            <div v-else>
              <span v-html="message"></span>
            </div>
          </b-col>
          <b-col class="text-right" cols="8">
            <b-button squared size="sm" variant="secondary" @click="discard">
              <i class="fa fa-chevron-left pr-1"></i>
              Back
            </b-button>
          </b-col>
        </b-row>
        <b-row></b-row>
      </b-card-footer>
    </b-card>




  </b-overlay>
</template>
  
<script>
import gql from "graphql-tag";


export default {
  name: "TicketsChange",
  components: {},
  mounted() {
    // this.accessdenied();
    this.ticketschange_load();
  },

  data() {
    return {
      type: "void",
      options_type: [
        { id: "void", label: "Void", disabled: false },
        { id: "charter", label: "Charter", disabled: false },
      ],
      canedit: ["agent", "eventcode", "slac", "yourref", "locked_at", "type"],
      item: {
        type: "",
        line_ri: "",
        passenger: "",
        title: "",
        firstname: "",
        surname: "",
        locked_at: null,
        eventcode: null,
        slac: null,
        agent: null,
        yourref: "",

        items: [{ name: "Passenger 1", ticketno: "abc", id: 0 }],
      },
      items: [],
      ticketschange: {
        title: "Tickets Change",
        icon: "fa fa-square text-orange",
        debounce: 500,
        busy: false,
        page: 1,
        denied: [],
        toolbarlibrary: [],
        tools:
          "go,export",
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-center w-50px",
          },
          {
            key: "dateissued",
            label: "Issued",
            sortable: true,
            class: "text-center",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = value.split(" ")[0];
              }
              return result;
            },
          },
          {
            key: "type",
            label: "Type",
            sortable: true,
            class: "text-center",
          },
          {
            key: "locator",
            label: "Locator",
            sortable: true,
            class: "text-center",
          },
          {
            key: "carrier_id",
            label: "Al",
            sortable: true,
            class: "d-none d-xl-table-cell text-center",
          },

          {
            key: "ticketno",
            label: "Ticket No",
            sortable: true,
            class: "text-center",
          },
          {
            key: "passenger",
            label: "Name",
            sortable: true,
            class: "d-none d-sm-table-cell",
            formatter: (value, key, item) => {
              let result = value;
              if (result) {
                if (result.length > 20) {
                  result = result.slice(0, 17) + "...";
                }
              }
              return result;
            },
          },
          {
            key: "datetravel",
            label: "Date Travel",
            sortable: true,
            class: "text-center",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = value.split(" ")[0];
              }
              return result;
            },
          },
          {
            key: "routing",
            label: "Routing",
            sortable: true,
            class: "text-center",
            formatter: (value, key, item) => {
              let result = value;
              if (result) {
                if (result.length > 12) {
                  result = result.slice(0, 12) + "...";
                }
              }
              return result;
            },
          },
          {
            key: "flightno",
            label: "FlightNo",
            sortable: true,
            class: "d-none d-lg-table-cell text-center",
            formatter: (value, key, item) => {
              let result = value;
              if (result) {
                if (result.length > 14) {
                  result = result.slice(0, 14) + "...";
                }
              }
              return result;
            },
          },
          {
            key: "class",
            label: "Class",
            sortable: true,
            class: "d-none d-lg-table-cell text-center",
          },
          {
            key: "seatno",
            label: "Seat",
            sortable: true,
            class: "d-none d-md-table-cell text-center",
            formatter: (value, key, item) => {
              let result = value;
              if (result) {
                if (result.length > 7) {
                  result = result.slice(0, 7) + "...";
                }
              }
              return result;
            },
          },
          // {
          //   key: "fare_type",
          //   label: "Fare Type",
          //   sortable: true,
          //   class: "text-center",
          // },
          {
            key: "fare",
            label: "Fare",
            sortable: true,
            class: "text-right",
            totalled: true,
            total: 0,
          },
          {
            key: "tax",
            label: "Tax",
            sortable: true,
            class: "text-right",
            totalled: true,
            total: 0,
          },
          // {
          //   key: "fee",
          //   label: "Fee",
          //   sortable: true,
          //   class: "text-right",
          //   totalled: true,
          //   total: 0,
          // },
          {
            key: "slac",
            label: "SL A/C",
            sortable: true,
            class: "text-center",
          },
          {
            key: "eventcode",
            label: "Event",
            sortable: true,
            class: "text-center",
          },
          // {
          //   key: "branch",
          //   label: "Branch",
          //   sortable: true,
          // },
          {
            key: "agent",
            label: "Agent",
            sortable: true,
          },
          {
            key: "invoiceno",
            label: "InvoiceNo",
            sortable: true,
            class: "text-center",
          },
          // {
          //   key: "lines",
          //   label: "#Sec",
          //   sortable: true,
          // },
          // {
          //   key: "actions",
          //   label: "Actions",
          //   class: "actions w-120px",
          // },
        ],
        badges: [
          {
            key: "carrier_id",
            type: "pill",
            class: "white",
          },
          {
            key: "ticketno",
            type: "pill",
            class: "orange",
          },
          {
            key: "class",
            type: "pill",
            class: "purple",
            title: "classname",
          },
          {
            key: "locator",
            type: "pill",
            class: "secondary",
          },
          {
            key: "lines",
            type: "pill",
            class: "white",
          },
          {
            key: "type",
            type: "badge",
            Charter: "teal",
            Ticket: "primary",
            Reissue: "primary",
            Void: "white",
            Refund: "white",
            EMD: "purple",
          },
          {
            key: "fare_type",
            type: "badge",
            Unknown: "white",
            Negotiated: "warning",
            Net: "purple",
            Manual: "secondary",
            Published: "white",
            Private: "pink",
            other: "secondary",
            formatter: (value, key, item) => {
              switch (parseInt(value)) {
                case "Unknown":
                  return "Unknown";
                  break;
                case "Negotiated":
                  return "Negotiated";
                  break;
                case "Net":
                  return "Net";
                  break;
                case "Manual":
                  return "Manual";
                  break;
                case "Published":
                  return "Published";
                  break;
                case "Private":
                  return "Private";
                  break;
                default:
                  return value;
              }
            },
          },
          {
            key: "queued",
            type: "badge",
            Yes: "danger",
            No: "info",
            formatter: (value, key, item) => {
              if (value == true) {
                return "Yes";
              } else if (value == false) {
                return "No";
              } else {
                return "";
              }
            },
          },
        ],
        items: [],
        selected: [],
      },
    };
  },
  computed: {
    readonly_namechange() {
      // if (this.user.permissions.includes('tickets.save') && this.item.type.toLowerCase() == 'charter' || this.item.type.toLowerCase()== 'void')

      if (this.user.permissions.includes('tickets.save') && (this.item.type.toLowerCase() == 'charter' || this.item.type.toLowerCase() == 'void')) {
        return false;
      }
      return true;
    },
  },
  methods: {

    async ticketschange_load(offset, limit, page) {

      this.ticketschange.items = this.selection

      if (this.ticketschange.items.length > 0) {
        if (this.selection[0].type.toLowerCase() == 'charter') {
          this.type = 'void'
        } else {
          this.type = 'charter'
        }

        this.item.line_ri = this.ticketschange.items[0].line_ri
        this.item.agent = this.ticketschange.items[0].agent

        this.options_type.forEach(function (v) {
          v.disabled = true
        });
        let found = this.options_type.find(o => o.id == this.type)
        if (found) {
          found.disabled = false
        }
      }

    },

    async saveit() {
      this.busy = true;

      let rows = [];
      this.selection.forEach(function (v) {
        rows.push({ id: v.id });
      });
      for (var j = 0; j < rows.length; j++) {
        rows[j].type = this.type
      }
      let variables = {
        rows,
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation tickets_save($rows: [Ticket_input]) {
              tickets_save(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },
    readonly(property) {
      let result = true;
      if (this.user.permissions.includes("tickets.save")) {
        this.canedit.forEach(function (action, index) {
          if (property == action) {
            result = false;
          }
        });
      }
      return result;
    },
  },
};
</script>
  
  
  